import React from 'react';
import { Bell, Radio, Volume2, VolumeX, X } from 'lucide-react';
import { ConnectionBadge } from './ConnectionBadge';
import { QuietHoursControl } from './QuietHoursControl';
import { VoiceSettings } from './VoiceSettings';

export const CommsHeader = ({
  status, soundsOn, onToggleSounds, showBell, onBell, quietHours, quietActive, onSaveQuietHours,
  ttsVoice, onVoiceChange, readAloud, onReadAloudChange,
}) => (
  <div className="comms-header">
    <h1 className="comms-title"><Radio size={26} /> Communications</h1>
    <div className="comms-header-actions">
      {showBell && (
        <button type="button" className="pill-toggle off" onClick={onBell} title="Turn on alerts" data-testid="alerts-bell">
          <Bell size={15} /> Alerts off
        </button>
      )}
      <button
        type="button"
        className={`pill-toggle ${soundsOn ? 'on' : 'off'}`}
        onClick={() => onToggleSounds(!soundsOn)}
        aria-pressed={soundsOn}
        title="Alert sounds and radio auto-play on this device"
        data-testid="sounds-toggle"
      >
        {soundsOn ? <Volume2 size={15} /> : <VolumeX size={15} />}
        {soundsOn ? 'Sounds on' : 'Sounds off'}
      </button>
      <VoiceSettings voice={ttsVoice} onVoiceChange={onVoiceChange} readAloud={readAloud} onReadAloudChange={onReadAloudChange} />
      <QuietHoursControl quietHours={quietHours} quietActive={quietActive} onSave={onSaveQuietHours} />
      <ConnectionBadge status={status} />
    </div>
  </div>
);

export const AlertsBar = ({ onEnable, onDismiss }) => (
  <div className="alerts-bar" data-testid="alerts-bar">
    <Bell size={16} />
    <span>Get a notification when a message or voice clip arrives while you are on another page.</span>
    <button type="button" className="alerts-enable" onClick={onEnable} data-testid="enable-alerts-button">Turn on alerts</button>
    <button type="button" className="alerts-dismiss" onClick={onDismiss} aria-label="Not now" data-testid="dismiss-alerts-button"><X size={16} /></button>
  </div>
);
